var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 5.833h-.834V4.167C10.833 1.867 8.967 0 6.667 0A4.168 4.168 0 002.5 4.167v1.666h-.833C.75 5.833 0 6.583 0 7.5v8.333C0 16.75.75 17.5 1.667 17.5h10c.916 0 1.666-.75 1.666-1.667V7.5c0-.917-.75-1.667-1.666-1.667zm-5 7.5c-.917 0-1.667-.75-1.667-1.666C5 10.75 5.75 10 6.667 10c.916 0 1.666.75 1.666 1.667 0 .916-.75 1.666-1.666 1.666zm2.583-7.5H4.083V4.167a2.586 2.586 0 012.584-2.584A2.586 2.586 0 019.25 4.167v1.666z",
    fill: "currentColor"
  })));
}
export default SvgLock;